import { Select } from "antd";
import { RoleListVm } from "api/generated/lumen";
import { useSelector } from "app/store";
import { ItemProps } from "models/common";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./RoleSelect.module.scss";
import { filterOptionsLabelAnyWhere } from "utils";

type RoleSelectProps = {
  handleSelectedRoles: (e: RoleListVm[]) => void;
  selectedRoles: RoleListVm[];
};

const RoleSelect = ({
  handleSelectedRoles,
  selectedRoles,
  ...props
}: RoleSelectProps) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.usersAndRolesAssign);

  const sortedRoles = useMemo(
    () =>
      [...(roles ?? [])]?.sort((a, b) => {
        if (a.isBuiltIn && !b.isBuiltIn) {
          return -1;
        } else if (!a.isBuiltIn && b.isBuiltIn) {
          return 1;
        }
        return a.name && b.name ? a.name?.localeCompare(b.name) : 0;
      }),
    [roles]
  );

  const options = useMemo<ItemProps[]>(
    () =>
      (sortedRoles || []).map((role) => ({
        label: role.name || "",
        value: role.id || "",
      })),
    [sortedRoles]
  );

  const handleChangeRoles = (value: (string | undefined)[]) => {
    const filteredRoles = roles?.filter(({ id }) => id && value.includes(id));
    handleSelectedRoles(filteredRoles || []);
  };

  return (
    <Select
      {...props}
      size="large"
      allowClear
      mode="tags"
      value={selectedRoles.map(({ id }) => id)}
      className={styles.selectWrapper}
      options={options}
      onChange={(e) => handleChangeRoles(e)}
      placeholder={t("rolesAndPermissionsSettings.roleSelect.placeholder")}
      filterOption={filterOptionsLabelAnyWhere}
      maxTagCount="responsive"
    />
  );
};

export default RoleSelect;
